// extracted by mini-css-extract-plugin
module.exports = {"root":"tentang_root__SxsY_","inner":"tentang_inner__3YFEk","header":"tentang_header__dRGiN","content":"tentang_content__Q-xfG"};